import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=48a2c5b2&scoped=true&"
import script from "./Empty.vue?vue&type=script&setup=true&lang=js&"
export * from "./Empty.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a2c5b2",
  null
  
)

export default component.exports